/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Actes numérisés seulement (AD-12901).
 *
 * Partout dans l'application : listes, statistiques, synthèse, recherche d'un
 * acte. Le filtre est OPTIONNEL côté API, qui sert aussi d'autres applications :
 * c'est cette application qui le demande, à chaque appel.
 */
export const FILTRE_NUMERISES = { numerise: 1 };

/** Même filtre, en paramètre d'URL (statistiques, synthèse). */
export const PARAM_NUMERISES = 'numerise=1';

/** Nom du même filtre sur les routes classiques `/actes-{type}`. */
export const FILTRE_NUMERISES_ACTES = { acteNumerise: '1' };
